<template>
  <v-container grid-list-xl>
    <v-layout row justify-center align-center wrap class="mt-4 pt-2">
      <v-flex xs12 sm12 md6 lg6 xl6>
        <h2 class="pb-4 mt-2">
          <span>Contact </span>
          <span class="green--text">Me</span>
        </h2>
        <div class="py-4 subheading font-weight-bold">
          <v-icon large color="green" left>fas fa-map-marker-alt</v-icon>
          <span>San Diego,&nbsp;</span>
          <span class="green--text">CA</span>
        </div>
        <div class="py-4 subheading font-weight-bold">
          <v-icon large color="green" left>fas fa-envelope</v-icon>
          <span>SugnheeW@</span>
          <span class="green--text">gmail.com</span>
        </div>
        <!-- <div class="py-4 subheading font-weight-bold">
          <v-icon large color="green" left>fas fa-phone</v-icon>
          <span>+387&nbsp;</span>
          <span class="green--text">61 596 676</span>
        </div> -->
        <!-- <div class="py-4 subheading font-weight-bold">
          <v-icon large color="green" left>fas fa-check</v-icon>
          <span>Freelance</span>
          <span class="green--text">Available</span>
        </div> -->
      </v-flex>

      <v-flex xs12 sm12 md6 lg6 xl6>
        <h2 class="pb-4 mb-4">
          <span>Contact </span>
          <span class="green--text">Form</span>
        </h2>

        <form method="POST" onsubmit="return false;">
          <v-text-field
            name="name"
            color="green"
            background-color="transparent"
            v-model="name"
            :error-messages="nameErrors"
            label="Name"
            required
            @blur="$v.name.$touch()"
          ></v-text-field>
          <v-text-field
            type="email"
            color="green"
            background-color="transparent"
            name="email"
            v-model="email"
            :error-messages="emailErrors"
            label="E-mail"
            required
            @blur="$v.email.$touch()"
          ></v-text-field>
          <v-textarea
            color="green"
            background-color="transparent"
            :counter="200"
            :error-messages="bodyErrors"
            v-model="body"
            label="Textarea"
            name="body"
            @blur="$v.body.$touch()"
          ></v-textarea>
          <v-btn
            @click="submit"
            type="submit"
            color="green"
            class="white--text"
            :disabled=" body.length < 5"
          >SEND MESSAGE</v-btn>
          <v-btn @click="clear">clear</v-btn>
          
          <!-- Response Display Area -->
          <div v-if="responseMessage" class="mt-4 pa-3" :class="responseClass">
            <v-icon :color="responseIcon.color" left>{{ responseIcon.icon }}</v-icon>
            {{ responseMessage }}
          </div>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email, minLength } from "vuelidate/lib/validators";
export default {
  metaInfo: {
    title: "SungheeWoo",
    titleTemplate: "%s-Contact",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Sugnhee Zaimovic's Contact Doboj Bosnia and Herzegovina Freelance Get in Touch ContactMe"
      },
      { charset: "utf-8" },
      { property: "og:title", content: "Sugnhee' Space" },
      { property: "og:site_name", content: "Sugnhee' Space" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://Sugnhee.space" },
      {
        property: "og:image",
        content: "https://i.imgur.com/Dcz2PGx.jpg"
      },
      {
        property: "og:description",
        content:
          "Sugnhee Zaimovic's Contact Doboj Bosnia and Herzegovina Freelance Get in Touch ContactMe"
      }
    ]
  },
  mixins: [validationMixin],
  validations: {
    name: { required },
    email: { required, email },
    body: { required, minLength: minLength(5) }
  },
  data() {
    return {
      name: "",
      email: "",
      body: "",
      responseMessage: "",
      responseType: ""
    };
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.responseMessage = "";

      // Send contact form to Slack via CORS proxy (same pattern as tutorial.4ai site)
      const webhookUrl =
        "https://hooks.slack.com/services/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";
      const proxyUrl =
        "https://corsproxy.io/?" + encodeURIComponent(webhookUrl);

      const nowSeconds = Math.floor(Date.now() / 1000);
      const payload = {
        text: `New Contact Form Submission from ${this.name} (${this.email})`,
        blocks: [
          {
            type: "header",
            text: {
              type: "plain_text",
              text: "📬 New Contact Form Submission"
            }
          },
          {
            type: "section",
            fields: [
              {
                type: "mrkdwn",
                text: `*Name:*\n${this.name}`
              },
              {
                type: "mrkdwn",
                text: `*Email:*\n${this.email}`
              },
              {
                type: "mrkdwn",
                text: `*Time:*\n<!date^${nowSeconds}^{date_short_pretty} {time}|Just now>`
              }
            ]
          },
          {
            type: "section",
            text: {
              type: "mrkdwn",
              text: `*Message:*\n${this.body}`
            }
          }
        ]
      };

      fetch(proxyUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      })
        .then(response => response.text().then(text => ({ ok: response.ok, text })))
        .then(({ ok, text }) => {
          if (!ok || text.trim().toLowerCase() !== "ok") {
            throw new Error(text || "Slack webhook error");
          }
          this.responseType = "success";
          this.responseMessage =
            "Message sent successfully! Thank you for reaching out.";
          this.$v.$reset();
          this.name = "";
          this.email = "";
          this.body = "";
        })
        .catch(error => {
          this.responseType = "error";
          this.responseMessage =
            "Error sending message. Please try again later. " + error.message;
        });
    },
    clear() {
      this.$v.$reset();
      this.name = "";
      this.email = "";
      this.body = "";
      this.responseMessage = "";
      this.responseType = "";
    }
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.required && errors.push("Name is required.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    },
    bodyErrors() {
      const errors = [];
      if (!this.$v.body.$dirty) return errors;
      !this.$v.body.minLength &&
        errors.push("Text must be at least 5 characters long");
      !this.$v.body.required && errors.push("Text is required");
      return errors;
    },
    responseClass() {
      return this.responseType === "success" ? "green lighten-5" : "red lighten-5";
    },
    responseIcon() {
      return this.responseType === "success" 
        ? { icon: "fas fa-check-circle", color: "green" }
        : { icon: "fas fa-exclamation-circle", color: "red" };
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
